import * as Yup from "yup";
import i18n from "../i18n";

export const SystemCodesSchema = Yup.object({
  masterCode: Yup.string(),
  arabicDesc: Yup.string().required(
    i18n.language === "en"
      ? "Arabic description is required"
      : "الوصف بالعربية مطلوب"
  ),
  engDesc: Yup.string().required(
    i18n.language === "en"
      ? "English description is required"
      : "الوصف بالإنجليزية مطلوب"
  ),
});
